import { Link } from 'react-router-dom';
import css from './AddComplianceItem.module.css';
import commonCSS from '../../_common/styles/Common.module.css';

function AddComplianceItem() {
    return (
        <div className={css.layout}>
            <div>
                <Link to="/compliance">
                    <span>
                        <i class="fa-solid fa-arrow-left"></i>
                    </span>
                </Link>
            </div>
            <div>
                <h2>Add compliance</h2>
                <div className={css.border}>
                    <form>
                        <label>Source</label>
                        <input />
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddComplianceItem;
